import Sports from './sports';

export default Sports;
